const initialState = {
  selectedPaymentOption: ''
};

export default function payment(state = initialState, action) {
  switch (action.type) {
    case 'SELECTED_PAYMENT_OPTION':
      return {
        ...state,
        selectedPaymentOption: action.selectedOption
      };
    case 'AVAILABLE_PAYMENT_LIST':
      return {
        ...state,
        paymentOptions: {
          ...state.paymentOptions,
          ...action.paymentOptions
        }
      };
      break;
    case 'DEFAULT_NOT_ALLOWED_PAYMENTS_FROM_LIST':
      let { disabled: notAllowedList = [] } = state;
      notAllowedList = [...notAllowedList];
      notAllowedList.push(action.paymentOption);
      return {
        ...state,
        disabled: notAllowedList,
        msg: action.msg ? action.msg : ''
      };
      break;
    case 'ENABLE_PAYMENTS_FROM_LIST':
      let { disabled: Disabled = [] } = state;
      Disabled = [...Disabled];
      const index = Disabled.indexOf(action.paymentOption);
      if (index != -1) {
        Disabled = Disabled.splice(index, 1);
      }
      return {
        ...state,
        disabled: Disabled,
        msg: ''
      };
      break;
    case 'SET_PAYMENT_GATEWAY':
      return {
        ...state,
        gatewayInfo: action.gatewayInfo
      };
      break;
    case 'UPDATE_PAYMENT_FORM_SUBMIT_STATUS':
      const newGatewayInfo = { ...state.gatewayInfo, enableAutoSubmit: action.value };
      return {
        ...state,
        gatewayInfo: newGatewayInfo
      };
      break;
    case 'UPDATE_PAYMENT_OPTIONS':
      let newPaymentOption = { ...state.paymentOptions, ...action.newOption };
      return {
        ...state,
        paymentOptions: newPaymentOption
      };
      break;
    case 'REMOVE_PAYMENT_FROM_PAYMENT_OPTIONS':
      newPaymentOption = { ...state.paymentOptions };
      delete newPaymentOption[action.option];
      return {
        ...state,
        paymentOptions: newPaymentOption
      };
    case 'REDEEM_TYPE':
      return {
        ...state,
        redeemType: action.redeemType
      };
      break;
    default:
      return state;
  }
}
